import { render, staticRenderFns } from "./veStuAssocChargeEdit.vue?vue&type=template&id=9e4545dc&scoped=true"
import script from "./veStuAssocChargeEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocChargeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4545dc",
  null
  
)

export default component.exports